export default "__VITE_ASSET__JAfVfp$6__"